export const GET_LEADS_STATUS = 'GET_LEADS_STATUS';
export const GET_LEADS_STATUS_SUCCESS = 'GET_LEADS_STATUS_SUCCESS';
export const GET_LEADS_STATUS_FAILURE = 'GET_LEADS_STATUS_FAILURE';

export const CHANGE_LEADS_STATUS_REQUEST = 'CHANGE_LEADS_STATUS_REQUEST';
export const CHANGE_LEADS_STATUS_REQUEST_SUCCESS = 'CHANGE_LEADS_STATUS_REQUEST_SUCCESS';
export const CHANGE_LEADS_STATUS_REQUEST_FAILURE = 'CHANGE_LEADS_STATUS_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/leads_status.constants.js